import { cycleEndDate, cycleStartDate, parsePeriod } from '@trestly/shared';
import { daysBetween, monthName } from './format';

/** «сентябрь 2026» — для подписей полей («Лимит на сентябрь 2026»). */
export function periodLabel(period: string): string {
  const { year, month } = parsePeriod(period);
  return `${monthName(month)} ${year}`;
}

export interface PeriodPace {
  /** Доля прошедшего периода, 0..1: засечка «где должен быть бюджет». */
  elapsed: number;
  /** Сколько дней осталось, включая сегодня. */
  daysLeft: number;
}

/**
 * Темп периода на сегодня. Период — окно цикла (с cycleStartDay), а не
 * календарный месяц, поэтому границы берём из shared.
 */
export function periodPace(period: string, cycleStartDay: number, todayIso: string): PeriodPace {
  const key = parsePeriod(period);
  const start = cycleStartDate(key, cycleStartDay);
  const end = cycleEndDate(key, cycleStartDay);
  const total = daysBetween(start, end) + 1;
  const elapsedDays = Math.min(Math.max(daysBetween(start, todayIso) + 1, 0), total);
  return {
    elapsed: total > 0 ? elapsedDays / total : 0,
    daysLeft: Math.max(daysBetween(todayIso, end) + 1, 0),
  };
}
